module.exports = __webpack_public_path__ + "static/climate_card_img3@2x-6ba72c8a9bb4862ffc6eeaaba5d5bc3a.jpg";